module.exports = __webpack_public_path__ + "img/clone-hover.3de2002e.svg";